import View from "../common/views/SidebarMoreView";
import components from "./components.js";
components.define("js-moreContentNav", View);